import clsx from "clsx"

import useIsDesktop from "@hooks/useIsDesktop"

import { Button } from "@atoms"

import { Popover } from "@molecules"
import PopoverFooter from "@molecules/Popover/PopoverFooter/PopoverFooter"

import styles from "./Prompt.module.scss"
import { PromptProps } from "./Prompt.types"

function Prompt(props: PromptProps) {
    const {
        title,
        body,
        isOpen,
        onOpenChange,
        confirmText,
        onConfirm,
        cancelText,
        onCancel,
        isDangerousOperation = false,
        isDisabled = false,
        isLoading = false,
        className,
        children,
    } = props

    const isDesktop = useIsDesktop()

    const handleConfirm = () => {
        onConfirm()
        onOpenChange?.(false)
    }

    const handleCancel = () => {
        onCancel?.()
        onOpenChange?.(false)
    }

    return (
        // Prompt is a modal: no isDismissable or overlay onClick, so it can only be closed via the buttons
        <Popover.Root isOpen={isOpen} onOpenChange={onOpenChange} isAnchored={false} isDismissable={false}>
            {isDesktop && <Popover.Overlay isActive={isOpen ?? false} />}
            <Popover.Viewport className={clsx(styles.viewport, className)}>
                <div className={styles.content}>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.body}>{body}</span>
                    {children}
                </div>
                <PopoverFooter.Root>
                    <PopoverFooter.LeftSide>
                        <Popover.Close asChild={true}>
                            <Button
                                size="lg"
                                variant="ghost"
                                noDebounce={true}
                                isDisabled={isDisabled || isLoading}
                                onClick={handleCancel}
                            >
                                {cancelText}
                            </Button>
                        </Popover.Close>
                    </PopoverFooter.LeftSide>
                    <PopoverFooter.RightSide>
                        <Button
                            size="lg"
                            variant={isDangerousOperation ? "danger" : "solid"}
                            noDebounce={true}
                            isDisabled={isDisabled || isLoading}
                            isLoading={isLoading}
                            onClick={handleConfirm}
                        >
                            {confirmText}
                        </Button>
                    </PopoverFooter.RightSide>
                </PopoverFooter.Root>
            </Popover.Viewport>
        </Popover.Root>
    )
}

export default Prompt
